import { IPaymentDetailInfo } from "@/domain/entities/payment";
import {
  IPaymentInfo,
  IPaymentInfoType,
} from "@/domain/entities/payment/paymentInfo.types";
import { Result } from "neverthrow";
import { HttpError } from "../shared/errors/httpError";
import { ParseError } from "../shared/errors/parseError";
import { IPaymentMethod } from "@/domain/entities/payment/paymentMethod.types";

export type HttpPaymentInfo = {
  payUid: string; // 결제 식별자 e.g. 202201210145455301285004055KKP,
  payTypeCode: string; // 결제유형코드 // PYT-PAY :지불, PYT-PAY :취소
  amount: number; // 결제금액  e.g. 4900,
  pgCode: string; // PG 코드 // PGC-KAKAOP :카카오페이, PGC-KCP :KCP
  statusCode: string; // 결제상태코드 // PYS-PAYEND :지불완료, PYS-CNLEND :취소완료
  statusTs: string; // 상태저장시점 e.g. 2022-01-21T10:46:04.590000000+09:00,
  endTs: string; // 결제종료시점 e.g. 2022-01-21T10:46:04.997000000+09:00
};

export type IPaymentInfoResponse = {
  data: HttpPaymentInfo[];
};

export type HttpPaymentBookInfo = {
  bookUid: string;
  bookDetailUid: string;
};

export type HttpPaymentDetailInfo = {
  payUid: string;
  payTypeCode: string; // 결제유형코드 // PYT-PAY :지불, PYT-PAY :취소
  amount: number;
  pgCode: string; // PG 코드 // PGC-KAKAOP :카카오페이, PGC-KCP :KCP
  statusCode: string; // 결제상태코드 // PYS-PAYEND :지불완료, PYS-CNLEND :취소완료
  statusTs: string; // 상태저장시점 e.g. 2022-01-21T10:46:04.590000000+09:00,
  endTs: string; // 결제종료시점 e.g. 2022-01-21T10:46:04.997000000+09:00
  details?: HttpPaymentBookInfo[];
};

export type HttpPaymentDetailInfoResponse = {
  data: HttpPaymentDetailInfo;
};

export enum HttpPGCode {
  KCP = "PGC-KCP",
  KakaoPay = "PGC-KAKAOP",
  FREE = "PGC-FREE",
}

export type HttpPaymentMethod = {
  code: HttpPGCode;
  name: string;
};

export type HttpPaymentMethodsResponse = {
  data: HttpPaymentMethod[];
};

export interface IPaymentInfoParser {
  toDomain(data: HttpPaymentInfo): Result<IPaymentInfo, ParseError>;
}

export interface IPaymentDetailInfoParser {
  toDomain(data: HttpPaymentDetailInfo): Result<IPaymentDetailInfo, ParseError>;
}

export interface IPaymentMethodParser {
  toDomain(data: HttpPaymentMethod): Result<IPaymentMethod, ParseError>;
}

export interface IPaymentRepository {
  getPaymentInfos(
    dateFrom: string,
    dateTo: string,
    paymentType?: IPaymentInfoType
  ): Promise<Result<IPaymentInfo[], ParseError | HttpError>>;

  getPaymentDetailInfo(
    payUid: string
  ): Promise<Result<IPaymentDetailInfo, ParseError | HttpError>>;

  getPaymentMethods(
    turnId?: string
  ): Promise<Result<IPaymentMethod[], ParseError | HttpError>>;
}
